import React from 'react';

//styles and icons 
import { Paper, Button, TextField, InputLabel, Typography, FormControl, Select } from '@material-ui/core';
import { Row, Col, Modal } from 'react-bootstrap';
import profileIcon from '../../../images/personal.svg';

export default function ProfileInfro(props) {
    let userData = props.userData
    return (
        <React.Fragment >
            <Paper 
                className="p-3" 
                style={{ borderTop: '2px solid #F27016', borderRadius: '0px' }}>
                <header className="row m-0 mb-3 align-items-center">
                    <Col className="text-left p-0" xs={8}>
                        <h6 className="bold mb-0">
                            <span ><img src={profileIcon} alt="icon" className="pr-3 pb-1" /></span>
                            Personal info
                        </h6>
                    </Col>
                </header>
                <main>
                    <Row className="m-0 bg-lightgrey p-2 mb-2">
                        <Col md={3}>
                            <p className="mb-0">Name</p>
                        </Col>
                        <Col md={9}>
                            <p className="mb-0">{userData?.name}</p>
                        </Col>
                    </Row>
                    <Row className="m-0 bg-lightgrey p-2 mb-2">
                        <Col md={3}>
                            <p className="mb-0">Headlines</p>
                        </Col>
                        <Col md={9}>
                            <p className="mb-0">{userData?.headlines}</p>
                        </Col>
                    </Row>
                    <Row className="m-0 bg-lightgrey p-2 mb-2">
                        <Col md={3}>
                            <p className="mb-0">Email address</p>
                        </Col>
                        <Col md={9}>
                            <p className="mb-0">{userData?.email}</p>
                        </Col>
                    </Row>
                    <Row className="m-0 bg-lightgrey p-2 mb-2">
                        <Col md={3}>
                            <p className="mb-0">Phone number</p>
                        </Col>
                        <Col md={9}>
                            <p className="mb-0">{userData?.phone}</p>
                        </Col>
                    </Row>
                    <Row className="m-0 bg-lightgrey p-2 mb-2">
                        <Col md={3}>
                            <p className="mb-0">Country</p>
                        </Col>
                        <Col md={9}>
                            <p className="mb-0">{userData?.country?.name}</p>
                        </Col>
                    </Row>
                    <Row className="m-0 bg-lightgrey p-2 mb-2">
                        <Col md={3}>
                            <p className="mb-0">City</p>
                        </Col>
                        <Col md={9}>
                            <p className="mb-0">{userData?.city?.name}</p>
                        </Col>
                    </Row>
                    <Row className="m-0 bg-lightgrey p-2 mb-2">
                        <Col md={3}>
                            <p className="mb-0">Address</p>
                        </Col>
                        <Col md={9}>
                            <p className="mb-0">{userData?.address}</p>
                        </Col>
                    </Row>
                    <Row className="m-0 bg-lightgrey p-2 mb-2">
                        <Col md={3}>
                            <p className="mb-0">Date of birth</p>
                        </Col>
                        <Col md={9}>
                            <p className="mb-0">{userData?.date_of_birth}</p>
                        </Col>
                    </Row>
                </main>
            </Paper>
        </React.Fragment >
    )
}